document.addEventListener('DOMContentLoaded', function () {
  // --- Search Overlay Logic ---
  
  const overlay = document.getElementById('search-overlay');
  const closeBtn = overlay?.querySelector('.search-overlay__close');
  let lastActiveElement = null;

  function showOverlay() {
    if (!overlay) return;

    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    lastActiveElement = document.activeElement;
    // Trap focus
    const focusable = overlay.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"])');
    if (focusable.length) focusable[0].focus();
    document.body.style.overflow = 'hidden';
  }

  function hideOverlay() {
    if (!overlay) return;
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastActiveElement) lastActiveElement.focus();
  }

  // Close button
  closeBtn?.addEventListener('click', function () {
    hideOverlay();
  });

  // ESC key closes overlay
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') {
      hideOverlay();
    }
  });

  // Intercept search trigger links (delegated)
  document.body.addEventListener('click', function (e) {
    const searchTrigger = e.target.closest('.js-search-trigger');
    if (searchTrigger && searchTrigger.tagName === 'A') {
      // Only intercept left click, no modifier keys
      if (
        e.button === 0 &&
        !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
      ) {
        e.preventDefault();
        showOverlay();
      }
    }
    // --- Cart Overlay Logic (delegated) ---
    const cartTrigger = e.target.closest('.js-cart-trigger');
    if (cartTrigger && cartTrigger.tagName === 'A') {
      
      if (
        e.button === 0 &&
        !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
      ) {
        e.preventDefault();
        openCartOverlay(e);
      }
    }
  });

  // Intercept overlay search form submission
  const searchForm = overlay?.querySelector('.search-overlay__form');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = searchForm.querySelector('input[name="q"]');
      const q = input ? input.value : '';
      if (q.trim() === '') return;
      fetchSearchResults(q);
    });
  }

  function fetchSearchResults(q) {
    // Fetch the overlay snippet with the new query
    fetch(`/search?q=${encodeURIComponent(q)}&section_id=search-overlay`)
      .then(res => res.text())
      .then(html => {
        // Parse the returned HTML and extract the overlay inner content
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newOverlay = temp.querySelector('#search-overlay');
        if (newOverlay) {
          // Replace the overlay container content
          const newContainer = newOverlay.querySelector('.search-overlay__container');
          const container = overlay.querySelector('.search-overlay__container');
          if (newContainer && container) {
            container.innerHTML = newContainer.innerHTML;
            // Re-attach close button event
            const newCloseBtn = container.querySelector('.search-overlay__close');
            newCloseBtn?.addEventListener('click', function () {
              hideOverlay();
            });
          }
        }
      });
  }

  // --- Cart Overlay Logic ---
  const cartOverlay = document.getElementById('cart-overlay');
  const cartCloseBtn = cartOverlay?.querySelector('.cart-overlay__close');

  function openCartOverlay(e) {

    if (cartOverlay) {

      cartOverlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartOverlay() {
    if (cartOverlay) {
      cartOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  if (cartCloseBtn) {
    cartCloseBtn.addEventListener('click', closeCartOverlay);
  }

  // Optional: close overlay when clicking outside the container
  if (cartOverlay) {
    cartOverlay.addEventListener('click', function(e) {
      if (e.target === cartOverlay) {
        closeCartOverlay();
      }
    });
  }

  // Intercept all link clicks and form submissions inside the cart overlay
  if (cartOverlay) {
    cartOverlay.addEventListener('click', function(e) {
      // Intercept remove links and prevent navigation
      const removeLink = e.target.closest('a');
      if (removeLink && removeLink.closest('#cart-overlay')) {
        const href = removeLink.getAttribute('href');
        if (href && href.includes('cart/change') && !removeLink.classList.contains('allow-navigation')) {
          e.preventDefault();
          // AJAX remove item
          fetch(href, { method: 'POST' })
            .then(res => res.text())
            .then(() => {
              // Reload overlay content
              location.reload();
            });
        }
      }
    });
    // Intercept form submissions (quantity update, etc.)
    cartOverlay.addEventListener('submit', function(e) {
      const form = e.target;
      if (form.closest('#cart-overlay')) {
        e.preventDefault();
        const formData = new FormData(form);
        fetch(form.action, {
          method: form.method,
          body: formData,
        })
          .then(res => res.text())
          .then(() => {
            // Reload overlay content
            location.reload();
          });
      }
    });
  }
});

// --- Dropdown Hover Logic ---
document.addEventListener('DOMContentLoaded', function () {

  const dropdownWrappers = document.querySelectorAll('.header__dropdown-wrapper');

  
  dropdownWrappers.forEach((wrapper, index) => {
    const trigger = wrapper.querySelector('.js-drop-down-trigger');
    const dropdown = wrapper.querySelector('.header__dropdown-content');

    
    if (!trigger || !dropdown) {
  
      return;
    }

  

    // Show dropdown on hover
    wrapper.addEventListener('mouseenter', () => {

      dropdown.style.display = 'block';
      dropdown.style.visibility = 'visible';
      dropdown.style.opacity = '1';
    });
    
    wrapper.addEventListener('mouseleave', () => {

      dropdown.style.display = 'none';
      dropdown.style.visibility = 'hidden';
      dropdown.style.opacity = '0';
    });

    // Allow normal redirect on click
    trigger.addEventListener('click', function (e) {
      
      // Let the default action happen (redirect)
      // No preventDefault here

    });
  });
}); 